import { createFileRoute, redirect } from '@tanstack/react-router'
import { onlineManager } from '@tanstack/react-query'
import { EmailVerification } from '@/pages/account/components/EmailVerification'
import { getUserProfileQueryOptions } from '@/queries/query'
import { queryKeys } from '@/queries/keys'

export const Route = createFileRoute('/account-verify-email')({
  beforeLoad: async ({ context }) => {
    if (!context.authContext.isAuthenticated) {
      throw redirect({
        to: '/auth/login',
      })
    }
    const userProfile = await context.queryClient.fetchQuery(
      getUserProfileQueryOptions(),
    )
    if (userProfile.data.admin.email_verified_at) {
      return redirect({
        to: '/account',
      })
    }
  },
  loader: ({ context }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      return context.queryClient.ensureQueryData(getUserProfileQueryOptions())
    }
    return context.queryClient.getQueryData(queryKeys.user.profile())
  },
  component: EmailVerification,
})
